import { useEffect, useState } from 'react';
import { TabItem } from '../../../components/v2/ui/Tabs/tabs.types';
import { TranslateType } from '../../translation/translationContext.types';
import {
  ACTIONS_TAB_ID,
  ALL_TAB_ID,
  ENTITY_TAB_ORDER,
  SHORTCUTS_TAB_ID,
} from '../globalSearch.constants';
import { SearchResultGroup, SearchableEntityType } from '../globalSearch.types';
import { getEntityTabLabel } from '../lib/getEntityTabLabel';
import { StaticCommandType } from '../staticCommands/staticCommands.types';

const COMMAND_TYPE_BY_TAB_ID: Partial<Record<string, StaticCommandType>> = {
  [ACTIONS_TAB_ID]: 'action',
  [SHORTCUTS_TAB_ID]: 'shortcut',
};

interface UseGlobalSearchActiveTabParams {
  tabs: TabItem[];
  orderedGroups: SearchResultGroup[];
  defaultTabId?: string;
  isStore: boolean;
  translate: TranslateType;
  isOpen: boolean;
}

const useGlobalSearchActiveTab = ({
  tabs,
  orderedGroups,
  defaultTabId,
  isStore,
  translate,
  isOpen,
}: UseGlobalSearchActiveTabParams) => {
  const [activeTabId, setActiveTabId] = useState<string>('');

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    if (tabs.length > 0 && !tabs.some((tab) => tab.id === activeTabId)) {
      setActiveTabId(defaultTabId ?? '');
    }
  }, [isOpen, tabs, activeTabId, defaultTabId]);

  const activeCommandType: StaticCommandType | null = COMMAND_TYPE_BY_TAB_ID[activeTabId] ?? null;
  const isEntityTab = ENTITY_TAB_ORDER.includes(activeTabId as SearchableEntityType);
  const activeEntityType = isEntityTab ? (activeTabId as SearchableEntityType) : null;
  const activeGroup = orderedGroups.find((group) => group.entityType === activeEntityType);
  const isAllTab = activeTabId === ALL_TAB_ID || activeTabId === '';
  const activeEntityLabel = activeGroup
    ? translate(getEntityTabLabel({ entityType: activeGroup.entityType, isStore }))
    : '';

  return {
    activeTabId,
    setActiveTabId,
    activeCommandType,
    activeEntityType,
    activeGroup,
    isAllTab,
    activeEntityLabel,
  };
};

export default useGlobalSearchActiveTab;
